/**
=========================================================
* Material Dashboard 2 React - v2.2.0
=========================================================

* Product Page: https://www.creative-tim.com/product/material-dashboard-react
* Copyright 2023 Creative Tim (https://www.creative-tim.com)

Coded by www.creative-tim.com

 =========================================================

* The above copyright notice and this permission notice shall be included in all copies or substantial portions of the Software.
*/

// Material Dashboard 2 React base styles
import colors from "assets/theme/base/colors";

// Material Dashboard 2 React helper functions
import pxToRem from "assets/theme/functions/pxToRem";

const { grey, transparent, info } = colors;

const tabs = {
  styleOverrides: {
    root: {
      position: "relative",
      backgroundColor: transparent.main,
      borderRadius: 0,
      borderBottom: `1px solid ${grey[300]}`,
      minHeight: "unset",
      padding: 0,
    },

    flexContainer: {
      height: "100%",
      position: "relative",
      zIndex: 10,
    },

    fixed: {
      overflow: "unset !important",
      overflowX: "unset !important",
    },

    vertical: {
      "& .MuiTabs-indicator": {
        width: "100%",
      },
    },

    indicator: {
      height: pxToRem(2),
      borderRadius: 0,
      backgroundColor: info.main,
      boxShadow: "none",
      transition: "all 300ms ease",
    },
  },
};

export default tabs;
